namespace Matrix.Data {
    export interface DataReportsForm {
        ReportName: Serenity.StringEditor;
        ReportKey: Serenity.StringEditor;
        ReportDescription: Serenity.StringEditor;
        Category: Serenity.StringEditor;
        Permission: Serenity.StringEditor;
        QueryType: Serenity.EnumEditor;
        ObjectName: Serenity.LookupEditor;
        DynamicSql: Serenity.TextAreaEditor;
        ParameterList: DataReportParametersEditor;
        ColumnList: DataReportColumnListEditor;
        VisibleSheets: DataReportsVisibleSheetsEditor;
        ReadonlyWorkbook: Serenity.BooleanEditor;
        ShowWorkbookInsertTab: Serenity.BooleanEditor;
        ShowWorkbookFormulasTab: Serenity.BooleanEditor;
        ShowWorkbookDataTab: Serenity.BooleanEditor;
        ShowWorkbookReviewTab: Serenity.BooleanEditor;
        ShowWorkbookHomeTab: Serenity.BooleanEditor;
        ShowWorkbookViewTab: Serenity.BooleanEditor;
        WorkbookHeight: Serenity.StringEditor;
        WorkbookFullScreenMode: Serenity.BooleanEditor;
        ExpandAllGroups: Serenity.BooleanEditor;
        FrozenColumns: Serenity.IntegerEditor;
        DisplayOrder: Serenity.IntegerEditor;
        IsVisible: Serenity.BooleanEditor;
        IsActive: Serenity.BooleanEditor;
    }

    export class DataReportsForm extends Serenity.PrefixedContext {
        static formKey = 'Data.DataReports';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!DataReportsForm.init)  {
                DataReportsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.EnumEditor;
                var w2 = s.LookupEditor;
                var w3 = s.TextAreaEditor;
                var w4 = DataReportParametersEditor;
                var w5 = DataReportColumnListEditor;
                var w6 = DataReportsVisibleSheetsEditor;
                var w7 = s.BooleanEditor;
                var w8 = s.IntegerEditor;

                Q.initFormType(DataReportsForm, [
                    'ReportName', w0,
                    'ReportKey', w0,
                    'ReportDescription', w0,
                    'Category', w0,
                    'Permission', w0,
                    'QueryType', w1,
                    'ObjectName', w2,
                    'DynamicSql', w3,
                    'ParameterList', w4,
                    'ColumnList', w5,
                    'VisibleSheets', w6,
                    'ReadonlyWorkbook', w7,
                    'ShowWorkbookInsertTab', w7,
                    'ShowWorkbookFormulasTab', w7,
                    'ShowWorkbookDataTab', w7,
                    'ShowWorkbookReviewTab', w7,
                    'ShowWorkbookHomeTab', w7,
                    'ShowWorkbookViewTab', w7,
                    'WorkbookHeight', w0,
                    'WorkbookFullScreenMode', w7,
                    'ExpandAllGroups', w7,
                    'FrozenColumns', w8,
                    'DisplayOrder', w8,
                    'IsVisible', w7,
                    'IsActive', w7
                ]);
            }
        }
    }
}
